import {get} from "aws-amplify/api";
import {fetchAuthSession} from "aws-amplify/auth";

export const useQuicksightEmbedding = () => {


    const getEmbedUrl = async (dashboardId: string) => {

        const {
            idToken
        } = (await fetchAuthSession()).tokens ?? {};

        if (!idToken) {
            return;
        }
        
        const path = '/';
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: idToken.toString(),
            },
            queryParams: {
                dashboardId: dashboardId
            }
        };

        const input = {
            apiName: 'QUICKSIGHT_EMBEDDING_API',
            path,
            options
        };

        const operation = get(input);
        const {body} = await operation.response;
        const parsed = await body.json() as { embedUrl: string };
        return parsed?.embedUrl

    }


    return {
        getEmbedUrl
    };
};